module.exports = __webpack_public_path__ + "static/media/infinite_campus_logo.5a20572e.jpg";